import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from 'store/app/entities/baseQuery';

const initialState = {};

const endpoints = build => ({
  getPlatformAiConfig: build.query({
    query: () => ({ url: 'v1/admin/ai/platform' }),
    transformResponse: response => response.data,
    providesTags: [{ type: 'AiConfigPlatform', id: 'PLATFORM' }],
  }),

  patchPlatformAiConfig: build.mutation({
    query: body => ({
      url: 'v1/admin/ai/platform',
      method: 'PATCH',
      body,
    }),
    transformResponse: response => response.data,
    invalidatesTags: [
      { type: 'AiConfigPlatform', id: 'PLATFORM' },
      { type: 'AiConfigCompany', id: 'LIST' },
      { type: 'AiConfigEffective', id: 'LIST' },
    ],
  }),

  getCompanyAiConfig: build.query({
    query: companyId => ({ url: `v1/admin/ai/companies/${encodeURIComponent(companyId)}` }),
    transformResponse: response => response.data,
    providesTags: (result, error, companyId) => [{ type: 'AiConfigCompany', id: companyId }],
  }),

  patchCompanyAiConfig: build.mutation({
    query: ({ companyId, body }) => ({
      url: `v1/admin/ai/companies/${encodeURIComponent(companyId)}`,
      method: 'PATCH',
      body,
    }),
    transformResponse: response => response.data,
    invalidatesTags: (result, error, { companyId }) => [
      { type: 'AiConfigCompany', id: companyId },
      { type: 'AiConfigEffective', id: 'LIST' },
    ],
  }),

  getEffectiveAiConfig: build.query({
    query: () => ({ url: 'v1/ai-config' }),
    transformResponse: response => response.data,
    providesTags: [{ type: 'AiConfigEffective', id: 'CURRENT' }],
  }),
});

const AiConfigSlice = createApi({
  reducerPath: 'aiConfigReducer',
  baseQuery,
  tagTypes: ['AiConfigPlatform', 'AiConfigCompany', 'AiConfigEffective'],
  initialState,
  keepUnusedDataFor: 60,
  endpoints,
});

export const {
  useGetPlatformAiConfigQuery,
  usePatchPlatformAiConfigMutation,
  useGetCompanyAiConfigQuery,
  usePatchCompanyAiConfigMutation,
  useGetEffectiveAiConfigQuery,
} = AiConfigSlice;

export const { middleware: aiConfigMiddleware, reducer: aiConfigReducer } = AiConfigSlice;

export default AiConfigSlice;
